import { render } from "./PraView.vue?vue&type=template&id=7f37f5d7&scoped=true"
import script from "./PraView.vue?vue&type=script&lang=js"
export * from "./PraView.vue?vue&type=script&lang=js"

import "./PraView.vue?vue&type=style&index=0&id=7f37f5d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f37f5d7"]])

export default __exports__